import React, { createContext, ReactNode } from 'react';
import { useLocation, Location } from 'react-router-dom';

export interface AppContextType {
    location: Location;
}

interface AppContextProviderProps {
    children: ReactNode;
}

export const AppContext = createContext<AppContextType>({
    location: {} as Location,
});

export const AppContextProvider: React.FC<AppContextProviderProps> = ({ children }) => {
    const location: Location = useLocation();

    return <AppContext.Provider value={{ location }}>{children}</AppContext.Provider>;
};
